"use client";
import { useEffect, useState } from "react";

const QUOTES = [
  {
    text: "Working with this studio is the closest an artist gets to cheating. We dropped the track and the charts reacted before we even posted.",
    name: "ELENA RICHTER",
    role: "ARTIST / HALOGEN RECORDS",
  },
  {
    text: "Our sound stopped sounding like everyone else's overnight. Six months later, our presets were being reverse-engineered.",
    name: "MARCUS OYELOWO",
    role: "VOCALIST / VESPER",
  },
  {
    text: "The single best sonic hire we've ever made. And it was one person.",
    name: "JUNE TAKAHASHI",
    role: "MANAGER / ATRIUM MUSIC",
  },
];

export function Testimonials() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % QUOTES.length), 6000);
    return () => clearInterval(t);
  }, []);
  const q = QUOTES[i];
  return (
    <section id="words" className="relative px-6 md:px-12 py-40 border-t border-border overflow-hidden">
      <div className="absolute left-12 top-12 font-mono text-xs uppercase tracking-widest text-muted-foreground">
        [004] — Field reports
      </div>
      <div className="max-w-[1400px] mx-auto">
        <div key={i} className="rise">
          <blockquote className="font-serif italic text-foreground leading-[0.95] tracking-tight"
            style={{ fontSize: "clamp(2.5rem, 7vw, 7.5rem)" }}>
            <span className="text-[oklch(0.94_0.27_128)]">"</span>{q.text}<span className="text-[oklch(0.94_0.27_128)]">"</span>
          </blockquote>
          <div className="mt-12 flex items-center gap-6">
            <div className="h-px flex-1 bg-border" />
            <div className="font-mono text-xs uppercase tracking-widest text-right">
              <div className="text-foreground">{q.name}</div>
              <div className="text-muted-foreground mt-1">{q.role}</div>
            </div>
          </div>

          <div className="mt-12 flex justify-center md:justify-start">
            <a href="#contact" className="btn-acid px-10 py-6 text-base md:text-lg">
              <span>→ Start Your Project Now</span>
            </a>
          </div>
        </div>

        <div className="mt-12 flex gap-3">
          {QUOTES.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setI(idx)}
              className={`h-1 transition-all ${idx === i ? "w-16 bg-[oklch(0.94_0.27_128)]" : "w-8 bg-border"}`}
              aria-label={`Quote ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
